/* ============================================================
   Gyakorlatok — a „Fotómontázs feladatleírás" lecke 15 gyakorlata
   (vistaappstore.hu, sfwd-lessons ID 9663) alapján.

   Minden sablon annyi címkézett kártyahelyet ad, amennyit a
   gyakorlat leírása kér, és megjeleníti a coach nyitókérdését.
   A `pack` az ajánlott kártyacsomag — a felhasználó bármikor
   válthat, ez csak a sablon kiválasztásakor ugrik a helyére.
   ============================================================ */

export const PACKS = [
  { key: 'erzelmek', name: 'Érzelmek', dir: 'erzelmek' },
  { key: 'celok', name: 'Célok', dir: 'celok' },
  { key: '3d', name: '3D motiváció', dir: '3D' },
  { key: 'kreativitas', name: 'Kreativitás', dir: 'Kreativitás' },
  { key: 'ido', name: 'Idő', dir: 'ido' },
  { key: 'ertekrend', name: 'Értékrend', dir: 'ertekek' }
];

export const DEFAULT_PACK = 'ertekrend';

/* draw = hány lapot húz a „Véletlen húzás" gomb ebben a gyakorlatban */
export const EXERCISES = [
  {
    id: 'free',
    name: 'Szabad montázs',
    slots: null,
    draw: 1,
    pack: null,
    prompt: 'Tedd a lapokat oda, ahová kívánkoznak — átfedhetik egymást, és szabadon méretezhetők.'
  },
  {
    id: 'tukor',
    name: '1. A jelenlegi állapotom tükre',
    slots: ['Ahogy most vagyok'],
    draw: 1,
    pack: 'erzelmek',
    prompt: 'Mit látsz rajta? Milyen érzés ránézni? Miért pont ez?'
  },
  {
    id: 'trilogia',
    name: '2. Életút trilógia',
    slots: ['Múlt', 'Jelen', 'Jövő'],
    draw: 3,
    pack: 'ido',
    prompt: 'Mi a történet? Hogyan kapcsolódnak? Mi az első kis lépés a jövő felé?'
  },
  {
    id: 'veletlen',
    name: '3. Véletlen húzás — a tudattalan üzenete',
    slots: ['A húzott lap'],
    draw: 1,
    pack: null,
    prompt: 'Van benne valami, amihez kapcsolódsz? Miért pont ez kellett most?'
  },
  {
    id: 'skala',
    name: '4. Érzelmi skála',
    slots: ['Kellemes', 'Semleges', 'Kellemetlen'],
    draw: 3,
    pack: 'erzelmek',
    prompt: 'Miért kellemes? Miért kellemetlen? Mit üzen a különbség?'
  },
  {
    id: 'hid',
    name: '5. A motivációs híd',
    slots: ['Most', 'Ahogy érezni szeretnék'],
    draw: 2,
    pack: '3d',
    prompt: 'Mi a különbség? Mi akadályoz? Mi az első lépés a hídon?'
  },
  {
    id: 'ertekek',
    name: '6. Értékek rangsorolása',
    slots: ['1. legfontosabb', '2.', '3.', '4.', '5.'],
    draw: 5,
    pack: 'ertekrend',
    prompt: 'Miért ez a sorrend? Melyiket élted meg legutóbb? Melyiket hagytad figyelmen kívül?'
  },
  {
    id: 'idoutazas',
    name: '7. Időutazás — gyerekkor és ma',
    slots: ['Gyerekként vágytam rá', 'Most szeretném'],
    draw: 2,
    pack: 'ido',
    prompt: 'Mennyire távolodtak el? Mit veszítettél el? Mit kell visszahozni?'
  },
  {
    id: 'tortenet',
    name: '8. Kreatív történet építés',
    slots: ['1.', '2.', '3.', '4.', '5.'],
    draw: 5,
    pack: 'kreativitas',
    prompt: 'Főszereplő, konfliktus, megoldás — miről szól valójában ez a történet?'
  },
  {
    id: 'felelem',
    name: '9. A félelmem és az erőm',
    slots: ['Legnagyobb félelmem', 'Legnagyobb erőm'],
    draw: 2,
    pack: 'erzelmek',
    prompt: 'Hogyan viszonyulnak egymáshoz? Mit tanulhatsz a félelemből?'
  },
  {
    id: 'burnout',
    name: '10. Burnout térkép',
    slots: ['Energiát ad', 'Elszívja', 'Lassít', 'Gyorsít'],
    draw: 4,
    pack: '3d',
    prompt: 'Melyikből van több az életedben?'
  },
  {
    id: 'ertekkonfliktus',
    name: '11. Értékkonfliktus feltárása',
    slots: ['Az egyik döntés', 'A másik döntés'],
    draw: 2,
    pack: 'ertekrend',
    prompt: 'Melyik érték fontosabb? Mit veszítesz, ha ezt választod?'
  },
  {
    id: 'szorongas',
    name: '12. Szorongás: előtte – közben – utána',
    slots: ['Előtte', 'Közben', 'Utána'],
    draw: 3,
    pack: 'erzelmek',
    prompt: 'Hol a legnagyobb félelem? Mi segítene?'
  },
  {
    id: 'parkapcsolat',
    name: '13. Párkapcsolati dinamika',
    slots: ['Én a kapcsolatban', 'A párom', 'A kapcsolatunk'],
    draw: 3,
    pack: 'erzelmek',
    prompt: 'Mennyire harmonikusak? Mi hiányzik?'
  },
  {
    id: 'blokkolo',
    name: '14. A kreativitás blokkolója',
    slots: ['Ami gátol', 'Ami felszabadítana'],
    draw: 2,
    pack: 'kreativitas',
    prompt: 'Mi tartja bent, és mi nyitná ki?'
  },
  {
    id: 'csoport',
    name: '15. Csoportos közös út',
    slots: null,
    draw: 1,
    pack: 'celok',
    prompt: 'Mindenki tegyen fel egy lapot: „ami téged jelképez a csapatban". Ez a csapat útja — hová tart?'
  }
];

export const getExercise = (id) => EXERCISES.find((e) => e.id === id) || EXERCISES[0];

export const getPack = (key) => PACKS.find((p) => p.key === key) || PACKS[PACKS.length - 1];

/* A sablon-helyek rácsa: a hosszú soroknál kényelmesebb két sorba tördelni,
   keskeny képernyőn pedig legfeljebb két oszlop fér el olvashatóan. */
export function slotColumns(count, boardWidth) {
  if (count <= 1) return 1;
  if (boardWidth < 520) return count <= 2 ? count : 2;
  if (count <= 3) return count;
  if (count === 4) return boardWidth < 760 ? 2 : 4;
  return boardWidth < 900 ? 3 : 5;
}
